import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SurveyInactiveDialog = ({ open, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle
                sx={{
                    backgroundColor: '#f5f5f5',
                    color: '#333333',
                    textAlign: 'center',
                    fontWeight: 'bold',
                }}
            >
                Survey Not Active
            </DialogTitle>
            <DialogContent
                sx={{
                    backgroundColor: '#ffffff',
                    p: 4,
                    textAlign: 'center',
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        mb: 2,
                        fontSize: '1.1rem',
                        color: '#333333',
                    }}
                >
                    This survey is currently inactive. Please try again later or contact the administrator for more information.
                </Typography>
            </DialogContent>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                <IconButton
                    onClick={onClose}
                    sx={{
                        color: '#B88552',
                        backgroundColor: '#f5f5f5',
                        '&:hover': {
                            backgroundColor: '#e0e0e0',
                        },
                        borderRadius: '50%',
                        padding: '10px',
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
        </Dialog>
    );
};

export default SurveyInactiveDialog;
